import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';
import CalendarScreen from './CalendarScreen';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent! Check your inbox and spam folder.');
      setEmail(''); // Clear the form
    } catch (error) {
      console.error('Password reset error:', error);
      
      // Handle specific Firebase errors
      switch (error.code) {
        case 'auth/user-not-found':
          setError('No account found with this email address');
          break;
        case 'auth/invalid-email':
          setError('Please enter a valid email address');
          break;
        case 'auth/too-many-requests':
          setError('Too many requests. Please try again later');
          break;
        default:
          setError('Failed to send password reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Calendar Screen as background */}
      <CalendarScreen />
      
      {/* Overlay for forgot password form */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(6px)',
          borderRadius: '50px',
          padding: '24px',
          width: '90%',
          maxWidth: '400px',
          position: 'relative',
          zIndex: 10
        }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{
            fontSize: '40px',
            fontWeight: '800',
            marginBottom: '24px',
            marginTop: 0,
            color: '#0F172A'
          }}>
            Reset Password 👋
          </h1>
          <p style={{
            fontSize: '14px',
            color: '#64748B',
            marginBottom: '16px',
            margin: 0
          }}>
            Enter your email and we'll send you a link to reset your password
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ marginBottom: '24px' }}>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: '100%',
              borderColor: '#e5e5e5',
              borderWidth: '1px',
              borderStyle: 'solid',
              borderRadius: '24px',
              paddingLeft: '16px',
              paddingRight: '16px',
              paddingTop: '16px',
              paddingBottom: '16px',
              marginBottom: '16px',
              fontSize: '16px',
              boxSizing: 'border-box',
              outline: 'none'
            }}
            placeholder="Email"
            disabled={loading}
          />

          {error && (
            <div style={{
              padding: '12px',
              backgroundColor: '#FFEBEE',
              color: '#D32F2F',
              borderRadius: '8px',
              marginBottom: '16px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          {message && (
            <div style={{
              padding: '12px',
              backgroundColor: '#E8F5E8',
              color: '#2E7D32',
              borderRadius: '8px',
              marginBottom: '16px',
              fontSize: '14px'
            }}>
              {message}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              height: '60px',
              backgroundColor: 'black',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '16px',
              marginTop: '32px',
              marginBottom: '16px',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              opacity: loading ? 0.5 : 1
            }}
          >
            <span style={{
              color: 'white',
              fontSize: '18px',
              fontWeight: '600'
            }}>
              {loading ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Sending...
                </div>
              ) : (
                'Send Reset Email'
              )}
            </span>
          </button>
        </form>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          fontSize: '14px',
          color: '#64748B'
        }}>
          <Link
            to="/"
            style={{
              color: '#2563eb',
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            Go Back
          </Link>
          <span style={{ color: '#D1D5DB' }}>•</span>
          <Link
            to="/support"
            style={{
              color: '#2563eb',
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            Need Help?
          </Link>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ForgotPasswordPage;